
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { LoginDto } from '@/models/dtos/loginDto'
import { UserDto } from '@/models/dtos/userDto'

@Component
export default class LoginCard extends Vue {
  @Prop({ type: Array, required: true }) users!: UserDto[];

  // Refs
  $refs!: {
    password: HTMLInputElement[];
  }

  // Data
  selectedUser: UserDto | null = null;
  loginUsers: UserDto[] = [];

  // Methods
  private selectUser(user: UserDto): void {
    if (this.selectedUser === user) {
      this.selectedUser = null
    } else {
      // Set user
      this.selectedUser = user

      // Focus input
      this.$nextTick(() => {
        const uIndex = this.users.findIndex(u => u === user)
        this.$refs.password[uIndex].focus()
      })
    }
  }

  private signin() {
    if (this.selectedUser) {
      const login: LoginDto = {
        userName: this.selectedUser.userName,
        password: this.selectedUser.password
      }

      // clear password
      this.selectedUser.password = ''

      // Emit
      this.$emit('signin', login)
    }
  }

  private getUserName(user: UserDto): string {
    if (!user?.firstName && !user?.lastName) return '-'

    return `${user.firstName} ${user.lastName}`
  }

  private getHeaderName(user: UserDto): string {
    if (!user?.firstName && !user?.lastName) return user.userName

    return `${user.firstName} ${user.lastName} (${user.userName})`
  }

  private initLoginUsers(): void {
    this.loginUsers = [...this.users]
  }

  // Lifecycle
  created() {
    this.initLoginUsers()
  }

  // Watchers
  @Watch('users')
  onPropertChange(value: UserDto, oldValue: UserDto) {
    this.initLoginUsers()
  }
}
